import { render, staticRenderFns } from "./BDXWizardBrokers.vue?vue&type=template&id=1cb16aa4"
import script from "./BDXWizardBrokers.vue?vue&type=script&lang=js"
export * from "./BDXWizardBrokers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports